export default {
  originCity: 'Abflugstadt auswählen',
  destinationCity: 'Anflugstadt auswählen',
  direct: 'Direktflug',
  indirect: '1+ Zwischenstopps',
  getPrices: 'Preise ansehen',
  directAvailable: 'Direktflug verfügbar von',
}
